module.exports = __webpack_public_path__ + "static/img/logo_color.ccd79601.png";